import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const MobileTooltipHeader = ({ children, classNames }) => (
  <div
    className={clsx(
      'flex flex-row pad-lr pad-1-t hidden-md-up border-dark-b',
      classNames
    )}
  >
    {children}
  </div>
);

MobileTooltipHeader.propTypes = {
  children: PropTypes.node.isRequired,
  classNames: PropTypes.string,
};

MobileTooltipHeader.defaultProps = {
  classNames: '',
};

export const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MobileTooltipHeader);
